<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='轮转表管理' :label2='this.title' :label3="this.monthtip" url="/cycle/plan/stulist"></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;display: none;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="Add">新增</el-button>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="SecName" label="轮转科室">
            </el-table-column>
            <el-table-column prop="Months" label="轮转月份">
            </el-table-column>
            <el-table-column label="轮转时间">
              <template slot-scope="scope">
                {{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.CPStatus == '1'">{{scope.row.CPStatusName}}</span>
                <span v-if="scope.row.CPStatus == '2'" style="color: green;">{{scope.row.CPStatusName}}</span>
                <span v-if="scope.row.CPStatus == '3'" style="color: red;">{{scope.row.CPStatusName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <!-- <el-button @click="Edit(scope.row)" type="text" size="medium" v-if="scope.row.CPStatus == '1'">修改</el-button> -->
                <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: red;" v-if="scope.row.CPStatus == '1'">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PlanList',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          cpstuid: '',
          token: '',
          pageSize: 99999,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        tableData: null,
        name: '',
        title: '',
        monthtip: '',
        searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/List',
        exportUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/ListOut',
        loading: true,
        IsSec: false
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      },
      formatFullDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      Edit: function(row) {
        this.$router.push({
          name: 'PlanEdit',
          params: {
            id: row.CPID,
            name: this.name,
            cpstuid: this.condition.cpstuid
          }
        })
      },
      Add: function() {
        this.$router.push({
          name: 'PlanAdd',
          params: {
            name: this.name,
            cpstuid: this.condition.cpstuid
          }
        })
      },
      Delete: function(row) {
        var args = {
          id: row.CPID,
          token: this.condition.token
        }
        var fd = this.$options.filters['formatDate']
        var message = this.name + " " + fd(row.CPBeginDate) + " 至 " + fd(row.CPEndDate)
        this.$utils.Delete(this.$utils.Url.zpgl + '/api/APICyclePlan/Delete', args, message, this.$refs.btnSearch.Search)
      },
      LoadMonthInfo: function() {
        var args = {
          token: this.condition.token,
          stuid: this.condition.cpstuid
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/LoadStuCPMonthInfo', args)
          .then(res => {
            if (res.data.Code === 0) {
              this.monthtip = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.name = this.$route.params.name
      this.condition.cpstuid = this.$route.params.id
      this.title = this.name + ' 轮转信息'
      this.LoadMonthInfo()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style>
</style>
